// import laptopImage from '../../images/laptop.png';
// import logoeasyplannerImage from '../../images/logoeasyplanner.png';
// import feature1Image from '../../images/feature1.png';

import ChristaImage from '../../images/Christa.png';
import GregorImage from '../../images/Gregor.jpg';
import JaronImage from '../../images/Jaron.jpg';
import RosalieImage from '../../images/Rosalie.jpg';
import RutgerImage from '../../images/Rutger.jpg';
import ThijsImage from '../../images/Thijs.png';
import UnknownImage from '../../images/Unknown.png';
import agendaLargeImage from '../../images/agenda large.png';
import agendaImage from '../../images/agenda.png';
import assignLargeImage from '../../images/assign large.png';
import assignImage from '../../images/assign.png';
import avatar1Image from '../../images/avatar1.jpg';
import avatar2Image from '../../images/avatar2.jpg';
import avatar3Image from '../../images/avatar3.jpg';
import avatar4Image from '../../images/avatar4.jpg';
import avatar5Image from '../../images/avatar5.jpg';
import avatar6Image from '../../images/avatar6.jpg';
import avatar7Image from '../../images/avatar7.jpg';
import avatar8Image from '../../images/avatar8.jpg';
import avatar9Image from '../../images/avatar9.jpg';
import avatar_allImage from '../../images/avatar_all.png';
import dashboardImage from '../../images/dashboard.png';
import djdImage from '../../images/djd.png';
import feature1Image from '../../images/feature1.png';
import feature10Image from '../../images/feature10.png';
import feature101Image from '../../images/feature101.png';
import feature102Image from '../../images/feature102.png';
import feature103Image from '../../images/feature103.png';
import feature104Image from '../../images/feature104.png';
import feature105Image from '../../images/feature105.png';
import feature106Image from '../../images/feature106.png';
import feature107Image from '../../images/feature107.png';
import feature108Image from '../../images/feature108.png';
import feature11Image from '../../images/feature11.png';
import feature12Image from '../../images/feature12.png';
import feature13Image from '../../images/feature13.png';
import feature14Image from '../../images/feature14.png';
import feature15Image from '../../images/feature15.png';
import feature16Image from '../../images/feature16.png';
import feature17Image from '../../images/feature17.png';
import feature18Image from '../../images/feature18.png';
import feature2Image from '../../images/feature2.png';
import feature21Image from '../../images/feature21.png';
import feature3Image from '../../images/feature3.png';
import feature4Image from '../../images/feature4.png';
import feature5Image from '../../images/feature5.png';
import feature6Image from '../../images/feature6.png';
import feature7Image from '../../images/feature7.png';
import feature8Image from '../../images/feature8.png';
import feature81Image from '../../images/feature81.png';
import feature9Image from '../../images/feature9.png';
import greenImage from '../../images/green.png';
import green2xImage from '../../images/green2x.png';
import header_oneImage from '../../images/header_one.jpg';
import header_twoImage from '../../images/header_two.jpg';
import iphoneImage from '../../images/iphone.jpg';
import laptopCopyImage from '../../images/laptop copy.png';
import laptopLargeImage from '../../images/laptop large.png';
import laptopImage from '../../images/laptop.png';
import logoeasyplannerImage from '../../images/logoeasyplanner.png';
import logoeasyplannersmallImage from '../../images/logoeasyplannersmall.png';
import logosAlrijneImage from '../../images/logos/Alrijne.png';
import logosAmsterdamUMCImage from '../../images/logos/Amsterdam UMC.png';
import logosAntoniusImage from '../../images/logos/Antonius.png';
import logosBergmanclinicsImage from '../../images/logos/Bergman clinics.png';
import logosFlevoziekenhuisImage from '../../images/logos/Flevoziekenhuis.png';
import logosGHZImage from '../../images/logos/GHZ.png';
import logosIjssellandImage from '../../images/logos/Ijsselland.png';
import logosMUMCImage from '../../images/logos/MUMC.png';
import logosNoordwestImage from '../../images/logos/Noordwest.png';
import logosOLVGImage from '../../images/logos/OLVG.png';
import logosRonaImage from '../../images/logos/Rona.png';
import logosSpaarneImage from '../../images/logos/Spaarne.png';
import opleidingsschemaLargeImage from '../../images/opleidingsschema large.png';
import opleidingsschemaImage from '../../images/opleidingsschema.png';
import overzichtImage from '../../images/overzicht.png';
import perspectiveImage from '../../images/perspective.png';
import rona_logoImage from '../../images/rona_logo.jpg';
import shatteredImage from '../../images/shattered.png';
import verzoekenLargeImage from '../../images/verzoeken large.png';
import verzoekenImage from '../../images/verzoeken.png';
import word_mapImage from '../../images/word_map.png';


import { Component, OnInit } from '@angular/core';
import templateString from './home.component.html';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvironmentService } from './../environment.service';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  selector: 'app-home',
	template: templateString
})
export class HomeComponent implements OnInit {
	public currentSection = 'pagetop';
	public hasScrolledDown = false;
	public menuUncollapsed = false;
	public pageId: any;
	public featureIndex: any; 
	public contactType;
	public submitted: any;
	public contactContents: any = {};
	public contactMailSent = false;
	public intervalTimer: any;
	public featureIds: any = [];
	public articleGroups: any = [];
	public article: any;

	public ChristaImage               = ChristaImage;
	public GregorImage                = GregorImage;
	public JaronImage                 = JaronImage;
	public RosalieImage               = RosalieImage;
	public RutgerImage                = RutgerImage;
	public ThijsImage                 = ThijsImage;
	public UnknownImage               = UnknownImage;
	public agendaLargeImage           = agendaLargeImage;
	public agendaImage                = agendaImage;
	public assignLargeImage           = assignLargeImage;
	public assignImage                = assignImage;
	public avatar1Image               = avatar1Image;
	public avatar2Image               = avatar2Image;
	public avatar3Image               = avatar3Image;
	public avatar4Image               = avatar4Image;
	public avatar5Image               = avatar5Image;
	public avatar6Image               = avatar6Image;
	public avatar7Image               = avatar7Image;
	public avatar8Image               = avatar8Image;
	public avatar9Image               = avatar9Image;
	public avatar_allImage            = avatar_allImage;
	public dashboardImage             = dashboardImage;
	public djdImage                   = djdImage;
	public feature1Image              = feature1Image;
	public feature10Image             = feature10Image;
	public feature101Image            = feature101Image;
	public feature102Image            = feature102Image;
	public feature103Image            = feature103Image;
	public feature104Image            = feature104Image;
	public feature105Image            = feature105Image;
	public feature106Image            = feature106Image;
	public feature107Image            = feature107Image;
	public feature108Image            = feature108Image;
	public feature11Image             = feature11Image;
	public feature12Image             = feature12Image;
	public feature13Image             = feature13Image;
	public feature14Image             = feature14Image;
	public feature15Image             = feature15Image;
	public feature16Image             = feature16Image;
	public feature17Image             = feature17Image;
	public feature18Image             = feature18Image;
	public feature2Image              = feature2Image;
	public feature21Image             = feature21Image;
	public feature3Image              = feature3Image;
	public feature4Image              = feature4Image;
	public feature5Image              = feature5Image;
	public feature6Image              = feature6Image;
	public feature7Image              = feature7Image;
	public feature8Image              = feature8Image;
	public feature81Image             = feature81Image;
	public feature9Image              = feature9Image;
	public greenImage                 = greenImage;
	public green2xImage               = green2xImage;
	public header_oneImage            = header_oneImage;
	public header_twoImage            = header_twoImage;
	public iphoneImage                = iphoneImage;
	public laptopCopyImage            = laptopCopyImage;
	public laptopLargeImage           = laptopLargeImage;
	public laptopImage                = laptopImage;
	public logoeasyplannerImage       = logoeasyplannerImage ;
	public logoeasyplannersmallImage  = logoeasyplannersmallImage;
	public logosAlrijneImage          = logosAlrijneImage;
	public logosAmsterdamUMCImage     = logosAmsterdamUMCImage;
	public logosAntoniusImage         = logosAntoniusImage;
	public logosBergmanclinicsImage   = logosBergmanclinicsImage;
	public logosFlevoziekenhuisImage  = logosFlevoziekenhuisImage;
	public logosGHZImage              = logosGHZImage;
	public logosIjssellandImage       = logosIjssellandImage;
	public logosMUMCImage             = logosMUMCImage;
	public logosNoordwestImage        = logosNoordwestImage;
	public logosOLVGImage             = logosOLVGImage;
	public logosRonaImage             = logosRonaImage;
	public logosSpaarneImage          = logosSpaarneImage;
	public opleidingsschemaLargeImage = opleidingsschemaLargeImage;
	public opleidingsschemaImage      = opleidingsschemaImage;
	public overzichtImage             = overzichtImage;
	public perspectiveImage           = perspectiveImage;
	public rona_logoImage             = rona_logoImage;
	public shatteredImage             = shatteredImage;
	public verzoekenLargeImage        = verzoekenLargeImage;
	public verzoekenImage             = verzoekenImage;
	public word_mapImage              = word_mapImage;

	// $scope.user = EnvironmentService.getUser();
	// if ($scope.user != undefined) {
	// 	$state.go("app.schedule");
	// }
	
	constructor(
		private router: Router,
		private environmentService: EnvironmentService,
		private route: ActivatedRoute,
		private http: HttpClient
	) { }

	toggleMenuCollapsed() {
		this.menuUncollapsed = !this.menuUncollapsed;
	}

	switchFeatureAndKillIntervalTimer(featureIndex) {
		clearInterval(this.intervalTimer);
		this.switchFeature(featureIndex);
	}

	switchFeature(featureIndex) {
		this.featureIndex = featureIndex;
	}

	ok(isValid) {
		this.submitted = true;
	
		if (isValid) {
			this.http.post('other_users/send_contact_mail',
                { contact_contents: this.contactContents }
            ).subscribe(result => {
                this.contactMailSent = true;
            });		
		}
	}

	showArticle(article) {
		this.article = article;
	}

	initialize() {
		var self = this;

		// if (this.environmentService.user != null) {
		// 	this.router.navigate(["/app/daySchedule"]);
		// } else if (this.environmentService.getUser() != null) {
		// 	// toastr.error("Uw sessie is verlopen. Log opnieuw in.");
		// 	this.router.navigate(["/login"]);
		// }
		var user = this.environmentService.getUser();

		if (user != null) {
			if (user.customer.customer_type_id == 2) {
				this.router.navigate(["/app/trainingSchedule"]);
			} else {
				this.router.navigate(["/app/daySchedule"]);
			}	
		} else {
			this.featureIds;

			if (this.pageId.startsWith("/contact")) {
				this.submitted = false;
	
				this.contactContents = {
					contactType: this.route.snapshot.queryParams["contactType"] ? this.route.snapshot.queryParams["contactType"] : "question",
					product: this.route.snapshot.queryParams["product"] ? this.route.snapshot.queryParams["product"] : ""
				};
			} else if (this.pageId == '/products?p=dagplanner-medisch-specialisten') {
				this.featureIds = [1, 21, 3, 4, 5, 6, 7, 8, 81, 9, 91, 12, 13, 14, 15, 16, 17, 18, 19];
			} else if (this.pageId == '/products?p=dagplanner-arts-assistenten') {
				this.featureIds = [1, 2, 3, 4, 5, 6, 7, 8, 81, 9, 91, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
			} else if (this.pageId == '/products?p=regionale-opleidingsplanner') {
				this.featureIds = [101, 102, 103, 104, 105, 106, 107, 108];
			}

			if (this.featureIds) {
				var i = 0; 

				this.featureIndex = this.featureIds[i++];

				if (this.intervalTimer) {
					clearInterval(this.intervalTimer);
				}

				this.intervalTimer = setInterval(() => {
					self.switchFeature(self.featureIds[i++ % self.featureIds.length]);
				}, 4000);
			}
			
		}
	}

	ngOnInit() {
		var self = this;

	    this.route.queryParams.subscribe(
            params => {
                this.pageId = this.router.url;
                this.initialize();
            }
        );

		this.http.get<any>("articles").subscribe(x => {
			var matchingArticles = x.filter(function(y) { return y.seo_id == self.route.snapshot.params["seoId"]; })

			if (matchingArticles.length > 0) {
				this.article = matchingArticles[0];
			} else {
				this.article = null;
			}

			for(var i=0; i < x.length; i++) {
				if (i+1 < x.length) {
					this.articleGroups.push([x[i], x[i+1]]);
					i++;
				} else {
					this.articleGroups.push([x[i]]);
				}
			}
        });
	}

	ngOnDestroy() {
		if (this.intervalTimer) {
			clearInterval(this.intervalTimer);
		}
	}
}